import Layout from '../views/layout/Layout'

export default {
  path: '/dataFolder',
  component: Layout,
  redirect: '/dataFolder/word',
  name: 'dataFolder',
  meta: {title: '数据目录', icon: 'data-center'},
  children: [
    {
      path: 'word',
      name: 'word',
      component: () => import('@/views/dataFolder/word.vue'),
      meta: {title: '检测数据 ', icon: 'word'}
    },
    {
      path: 'done',
      name: 'done',
      component: () => import('@/views/dataFolder/done.vue'),
      meta: {title: '完成数据', icon: 'api_order'},
    },
    {
      path: 'report',
      name: 'report',
      component: () => import('@/views/dataFolder/report/index.vue'),
      meta: {title: '查看报告与问卷详情', icon: 'store-list'},
      hidden: true
    },
    {
      path: 'medicineManage',
      name: 'medicineManage',
      component: () => import('@/views/dataFolder/medicineManage/index.vue'),
      meta: {title: '药品管理', icon: 'constitution'},
    },
    {
      path: 'medicineLabel',
      name: 'medicineLabel',
      component: () => import('@/views/dataFolder/medicineLabel/index.vue'),
      meta: {title: '药品标注', icon: 'word'},
    },
    {
      path: 'relation',
      name: 'relation',
      component: () => import('@/views/dataFolder/relation/index.vue'),
      meta: {title: '药店关系', icon: 'relation'},
    },
     {
      path: 'medicineConvert',
      name: 'medicineConvert',
      component: () => import('@/views/dataFolder/medicineConvert/index.vue'),
      meta: {title: '药品转换', icon: 'medicine-convert'}, 
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/dataFolder.js